import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10bddd50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-input font-bold" }
const _hoisted_2 = { key: 0 }

import { ref, watch } from "vue";
// PrimeVueのマルチセレクトボタンコンポーネント
import SelectButton from "primevue/selectbutton";

/**
 * 配信グループの顧客フィルター用タグ選択コンポーネント
 *
 * タグの種類（manual、partner、additional等）に応じて色分けされた
 * マルチセレクトボタンを提供します。
 *
 * @example
 * <FilterDistributionGroupCustomer
 *   label="タグで絞り込み"
 *   :filterTags="selectedTags"
 *   :options="availableTags"
 *   :isLoading="false"
 *   :finalSetting="false"
 *   tagClass="custom-tag-class"
 *   @update:filterTags="handleTagUpdate"
 * />
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterDistributionGroupCustomer',
  props: {
    label: null,
    filterTags: null,
    options: null,
    isLoading: { type: Boolean },
    finalSetting: { type: Boolean },
    tagClass: null
  },
  emits: ["update:filterTags"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** フィルターのラベル表示 */
  label: string;
  /** 現在選択されているタグの配列 */
  filterTags: Array<any>;
  /** 選択可能なタグのオプション配列 */
  options: Array<any>;
  /** ローディング状態 */
  isLoading: boolean;
  /** 最終設定モード（編集不可にするかどうか） */
  finalSetting: boolean;
  /** カスタムタグクラス名 */
  tagClass: string;
};

// Vue 3 Composition APIの基本機能


/**
 * タグ選択が変更された時に発火するイベント
 * @param filterTags - 更新されたタグの配列
 */


/**
 * ローカルのフィルタータグ状態
 * props.filterTagsの変更を監視して同期を保つ
 */
const localFilterTags = ref(props.filterTags);

/**
 * props.filterTagsの変更を監視してlocalFilterTagsを同期
 * 親コンポーネントからの更新を反映する
 */
watch(
  () => props.filterTags,
  (newVal: Array<any>) => {
    localFilterTags.value = newVal;
  }
);

/**
 * localFilterTagsの変更を監視して親コンポーネントに通知
 * タグ選択の変更を親コンポーネントに反映する
 */
watch(
  () => localFilterTags.value,
  (newVal: Array<any>) => {
    emits("update:filterTags", newVal);
  }
);

/**
 * タグタイプに応じたCSSクラスのマッピング
 *
 * - additional: オレンジ色（自動付与タグ）
 * - manual: 青色（手動タグ）
 * - template: 青色（テンプレートタグ）
 * - partner: 緑色（パートナータグ）
 */
const tagClassMapping = {
  additional: "tag-orange",
  manual: "tag-blue",
  template: "tag-blue",
  partner: "special-selected-tag",
};

return (_ctx: any,_cache: any) => {
  return (!__props.isLoading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["form-filter-content pt-2 tag-filter", { 'pointer-events-none': __props.finalSetting }])
      }, [
        _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
        _createVNode(_unref(SelectButton), {
          modelValue: localFilterTags.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFilterTags).value = $event)),
          options: __props.options,
          optionLabel: "label",
          optionValue: "value",
          "aria-labelledby": "multiple",
          class: "ml-4",
          name: "filter-time",
          multiple: ""
        }, {
          option: _withCtx(({ option }) => [
            (Array.isArray(option.label))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.label, (label, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: _normalizeClass(["p-button-label tag-label", __props.tagClass])
                    }, _toDisplayString(label), 3))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["p-button-label tag-label", __props.tagClass || tagClassMapping[option.type as keyof typeof tagClassMapping]])
                }, _toDisplayString(option.label), 3))
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})